import React, { Component } from "react";

import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import OutsideClickHandler from "react-outside-click-handler";
import HODashboardService from "../../services/HODashaboardService";
import StorageService from "../../services/Storage";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import { Roles } from "../../constants/constant.role";

class YTDFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getUserDetail: StorageService.getUserDetail(),
      dropdownOpen: false,
      isLoader: false,
      dropdownOpenYtd: false,
      regionData: [],
      monthOptions: [],
      areaData: [],
      yearOptions: [],
      allQuarter: [],
      allZone: [],
      isLoading: false,
      dealerRole: null,
      ActiveText: "",
      Xerox: {},
      year_name_value: {},
      year_name: null,
      monthName: null,
      controls: {
        area: {
          value: "",
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
        },
        month: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
        },
        year: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
        },
        region: {
          value: "",
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
        },
        zone: {
          value: "",
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
        },
        isAllIndia: {
          value: true,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
        },
        quarter: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
        },
      },
    };
  }

  componentDidMount() {
    this.filterAPI();
  }

  toggleYtd = () => {
    let { dropdownOpenYtd } = this.state;
    this.setState({
      dropdownOpenYtd: !dropdownOpenYtd,
    });
  };

  toggleClose = () => {
    let { controls, Xerox } = this.state;
    controls["month"].value = Xerox.month;
    controls["year"].value = Xerox.year;
    controls["quarter"].value = Xerox.quarter;
    this.setState(
      {
        controls,
        dropdownOpenYtd: false,
        monthName: this.state.Xerox.monthName
          ? this.state.Xerox.monthName
          : null,
      },
      () => {
        let { yearOptions, year_name_value } = this.state;
        if (controls.year && controls.year.value) {
          year_name_value = yearOptions.filter(
            (x) => x.value == controls.year.value
          );
        }
        if (this.state.Xerox.month) {
          this.monthChangeName(this.state.Xerox.month);
        }
        this.filterAPI();
        this.setState({ year_name_value });
      }
    );
  };

  onChangeYear = (e) => {
    let { controls,
      // yearOptions, year_name_value
    } = this.state;
    // if (e && e.target.value) {
    //   year_name_value = yearOptions.filter(x => x.value == e.target.value);
    // }
    controls["year"].value = e.target.value;
    controls["quarter"].value = null;
    controls["month"].value = null;
    this.setState(
      {
        controls,
      },
      () => {
        this.filterAPI();
      }
    );
  };

  addQuarter = (e) => {
    if (e.target.value === "All" || e.target.value === "all") {
      e.target.value = null;
    }
    const { controls } = this.state;
    const { quarter, month } = controls;
    this.setState({ monthName: null });
    month.value = "";
    quarter.value = e.target.value;
    this.setState(
      {
        controls,
      },
      () => {
        this.filterAPI();
      }
    );
  };

  onChangeMonth = (e) => {
    if (e.target.value === "All" || e.target.value === "all") {
      e.target.value = null;
    }
    const { controls } = this.state;
    const { month } = controls;
    month.value = e.target.value;
    this.setState(
      {
        controls,
      },
      () => {
        // this.monthChangeName(month.value);
        this.filterAPI();
      }
    );
  };

  monthChangeName = (monthIndex) => {
    if (monthIndex) {
      if (monthIndex === 1 || monthIndex === '1') {
        this.setState({ monthName: "January" });
      } else if (monthIndex === 2 || monthIndex === '2') {
        this.setState({ monthName: "February" });
      } else if (monthIndex === 3 || monthIndex === '3') {
        this.setState({ monthName: "March" });
      } else if (monthIndex === 4 || monthIndex === '4') {
        this.setState({ monthName: "April" });
      } else if (monthIndex === 5 || monthIndex === '5') {
        this.setState({ monthName: "May" });
      } else if (monthIndex === 6 || monthIndex === '6') {
        this.setState({ monthName: "June" });
      } else if (monthIndex === 7 || monthIndex === '7') {
        this.setState({ monthName: "July" });
      } else if (monthIndex === 8 || monthIndex === '8') {
        this.setState({ monthName: "August" });
      } else if (monthIndex === 9 || monthIndex === '9') {
        this.setState({ monthName: "September" });
      } else if (monthIndex === 10 || monthIndex === '10') {
        this.setState({ monthName: "October" });
      } else if (monthIndex === 11 || monthIndex === '11') {
        this.setState({ monthName: "November" });
      } else if (monthIndex === 12 || monthIndex === '12') {
        this.setState({ monthName: "December" });
      }
    } else {
      this.setState({ monthName: null });
    }
  };

  AddYTDFilter = (e) => {
    e.preventDefault();
    this.toggleYtd();
    const { controls } = this.state;
    const { month, year, quarter } = controls;
    let filter = {
      m: month.value,
      y: year.value,
      q: quarter.value,
    };
    let Xerox = {
      month: this.state.controls.month.value,
      year: this.state.controls.year.value,
      quarter: this.state.controls.quarter.value,
    };
    this.setState({
      Xerox,
    });
    this.monthChangeName(month.value);
    let { yearOptions, year_name_value } = this.state;
    if (year && year.value) {
      year_name_value = yearOptions.filter((x) => x.value == year.value);
    }
    this.setState({ year_name_value });
    this.props.getOffTakeSalesEntry(filter);
    if (StorageService.getUserDetail().type !== Roles.FLEET_MANAGER_ROLE) {
      this.props.getDirectIndirectData(filter);
      this.props.getFleetStatusCount(filter);
    }
    this.setState({
      year_name:
        year_name_value && year_name_value[0] && year_name_value[0].name,
    });
  };

  filterAPI = () => {
    const { controls } = this.state;
    const { month, year, quarter } = controls;

    let filter = {
      y: year.value ? year.value : null,
      m: month.value ? month.value : null,
      q: quarter.value ? quarter.value : null,
    };
    this.setState({ isLoader: true });
    HODashboardService.filterAPI(filter)
      .then((res) => {
        if (res.data.data) {

          if (this.props.year2020) {
            res.data.data.year.splice(1, 0, { name: "2020-21", key: "2020-21", value: 2020 });
          }

          this.setState({ isLoader: false });
          this.setState(
            {
              yearOptions: res.data.data.year ? res.data.data.year : [],
              monthOptions: res.data.data.month ? res.data.data.month : [],
              allQuarter: res.data.data.quarter ? res.data.data.quarter : [],
              allZone: res.data.data.zone ? res.data.data.zone : [],
              ActiveText: res.data.data.note ? res.data.data.note : "",
            },
            () => {
              this.state.year_name_value = this.state.yearOptions.filter(
                (x) => x.value == this.state.controls.year.value
              );
              this.props.updateZone();
              var { controls } = this.state;
              if (this.state.allQuarter.length === 1) {
                controls["quarter"].value = this.state.allQuarter[0].value;
                this.setState({
                  controls,
                });
              }
              if (this.state.monthOptions.length === 1) {
                controls["month"].value = this.state.monthOptions[0].value;
                this.setState({
                  controls,
                });
              }

              if (
                !this.state.controls.year.value &&
                this.state.yearOptions &&
                this.state.yearOptions[0]
              ) {
                controls["year"].value = this.state.yearOptions[0].value;
                controls["quarter"].value = this.state.allQuarter[0].value;
                controls["month"].value = this.state.monthOptions[0].value;
                let Xerox = {
                  month: this.state.monthOptions[0].value,
                  year: this.state.yearOptions[0].value,
                  quarter: this.state.allQuarter[0].value,
                };
                this.setState(
                  {
                    controls,
                    year_name: this.state.yearOptions[0].name,
                    Xerox,
                  },
                  () => {
                    this.state.year_name_value = this.state.yearOptions.filter(
                      (x) => x.value == this.state.controls.year.value
                    );
                    this.monthChangeName(controls.month.value);
                    this.props.getOffTakeSalesEntry();
                    if (
                      StorageService.getUserDetail().type !== Roles.FLEET_MANAGER_ROLE
                    ) {
                      this.props.getDirectIndirectData();
                      this.props.getFleetStatusCount();
                    }
                  }
                );
              }
            }
          );
          this.props.updateZone();
        }
      })
      .catch((err) => {
        this.setState({ isLoader: false });
        console.log("err", err);
      });
  };

  resetFilter = () => {
    const { controls } = this.state;
    const { month, year, quarter } = controls;
    month.value = null;
    year.value = null;
    quarter.value = null;
    this.setState(
      {
        controls,
        monthName: null,
      },
      () => {
        this.setState({ monthName: null });
        this.filterAPI();
        // this.props.getOffTakeSalesEntry("");
        // if (this.state.getUserDetail.type != Roles.FLEET_MANAGER_ROLE) {
        //   this.props.getDirectIndirectData("");
        //   this.props.getFleetStatusCount("");
        // }
        let Xerox = {
          month: null,
          year: null,
          quarter: null,
        };
        this.filterAPI();
        this.setState(
          {
            Xerox,
          },
          () => {
            this.setState(
              {
                year_name_value: this.state.yearOptions.filter(
                  (x) => x.value == this.state.controls.year
                ),
              },
              () => {
                this.setState({
                  year_name:
                    this.state.year_name_value &&
                    this.state.year_name_value[0] &&
                    this.state.year_name_value[0].name,
                });
              }
            );
          }
        );
      }
    );
    this.toggleYtd();
  };

  render() {
    const {
      // regionData,
      // areaData,
      // dealerRole,
      yearOptions,
      monthOptions,
      allQuarter,
    } = this.state;
    const { controls } = this.state;
    const {
      // area, zone, region, 
      month, year, quarter } = controls;

    const yearOptionToDisplay = yearOptions.map((y) => (
      <option value={y.value}>{y.name}</option>
    ));
    const allQuarterToDisplay = allQuarter.map((q) => (
      <option value={q.value}>{q.name}</option>
    ));
    const monthOptionToDisplay = monthOptions.map((m) => (
      <option value={m.value}>{m.name}</option>
    ));

    return (
      <>
        <OutsideClickHandler onOutsideClick={this.toggleClose}>
          <Dropdown
            group
            isOpen={this.state.dropdownOpenYtd}
            toggle={this.toggleYtd}
            size="sm"
            className="dropdown-toggle-ho-all-india-filter-wrapper"
            style={{
              height:
                (StorageService.getUserDetail().type === Roles.FLEET_MANAGER_ROLE ||
                  StorageService.getUserDetail().type ===
                  Roles.ZONAL_FLEET_MANAGER_ROLE ||
                  StorageService.getUserDetail().type ===
                  Roles.HEAD_OFFICE_BAADSHAH_ROLE) &&
                "34px",
              width:
                StorageService.getUserDetail().type === Roles.FLEET_MANAGER_ROLE &&
                "50px",
            }}
          >
            <DropdownToggle
              color="white"
              caret
              className="dropdown-toggle-ho-all-india-filter"
            >
              {this.state.monthName ? `${this.state.monthName},` : ""}{" "}
              {this.state.controls.quarter.value &&
                this.state.controls.quarter.value
                ? `Q${this.state.controls.quarter.value},`
                : ""}{" "}
              {this.state.year_name ? `${this.state.year_name}` : ""}
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-ho-all-india-filter">
              {this.state.isLoader && <CustomSpinner />}
              <div className="custom-dropdown-header">
                <span className="custom-dropdown-header-title cursor-pointer">
                  Filter
                </span>
                <img
                  className="cursor-pointer"
                  src="/images/close1.svg"
                  onClick={this.toggleClose}
                  alt="close1"
                />
              </div>
              <Row
                className="p-2"
                style={{ margin: "-5px", marginTop: "10px" }}
              >
                <Col xl="12" xs="12" sm="12" md="12">
                  <FormGroup>
                    <Label className="lbl-14px">Year</Label>
                    <br />
                    <select
                      name="year"
                      className="form-control cursor-pointer"
                      value={year.value}
                      onChange={(e) => {
                        this.onChangeYear(e);
                      }}
                    >
                      {yearOptionToDisplay}
                    </select>
                  </FormGroup>
                </Col>
                <Col xl="12" xs="12" sm="12" md="12">
                  <FormGroup>
                    <Label className="lbl-14px">Quarter</Label>
                    <br />
                    <select
                      name="quarter"
                      value={quarter.value}
                      className="form-control cursor-pointer"
                      onChange={(e) => {
                        this.addQuarter(e);
                      }}
                    >
                      {allQuarterToDisplay}
                    </select>
                  </FormGroup>
                </Col>
                <Col xl="12" xs="12" sm="12" md="12">
                  <FormGroup>
                    <Label className="lbl-14px">Month</Label>
                    <br />
                    <select
                      name="month"
                      className={
                        !monthOptions.length
                          ? "form-control"
                          : "form-control cursor-pointer"
                      }
                      value={month.value}
                      disabled={!monthOptions.length}
                      onChange={(e) => {
                        this.onChangeMonth(e);
                      }}
                    >
                      {/* <option value="" selected>
                        All
                      </option> */}
                      {monthOptionToDisplay}
                      {/* {
                  months.map((item, j) => (
                    <option className="text-capitalize" value={item.value}>{item.key}</option>
                  ))
                } */}
                    </select>
                  </FormGroup>
                </Col>
              </Row>
              <Row style={{ margin: "auto" }}>
                <Col
                  xl="6"
                  xs="6"
                  md="6"
                  className="text-align-right mt-3"
                  style={{ padding: "0px" }}
                >
                  <Button
                    className="mb-1 mr-1 btn-pill action-button profile-cancel-button"
                    color="dark"
                    onClick={() => {
                      this.resetFilter();
                    }}
                  >
                    Reset
                  </Button>
                </Col>
                <Col xl="6" xs="6" md="6" className="text-align-right mt-3">
                  <Button
                    className="mb-1 mr-1 btn-pill action-button profile-save-button"
                    color="warning"
                    onClick={(e) => {
                      this.AddYTDFilter(e);
                    }}
                  >
                    Apply
                  </Button>
                </Col>
              </Row>
            </DropdownMenu>
          </Dropdown>
        </OutsideClickHandler>
      </>
    );
  }
}

export default YTDFilter;
